__turbopack_context__.v({
  "badge": "q-CTvW_badge",
  "pill": "q-CTvW_pill",
  "row": "q-CTvW_row",
});
